import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import KsDlDetailedRenewal from './KsDlDetailedLicense';

class KsDlModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  sendNavigationRequest() {
    return null;
  }

  render() {
    const { show, } = this.state;
    const { license, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              License Id&nbsp;
              {license.id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <KsDlDetailedRenewal license={license} />;
              }
              return undefined;
            })()}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

KsDlModal.propTypes = {
  license: PropTypes.instanceOf(Object).isRequired,
};

export default KsDlModal;
